<template>
  <div class="sc-analytics-summary columns">
    <sc-page-loading v-if="loading" />

    <div
      v-for="(summary, index) in summaries"
      :key="summary.title"
      class="column">
      <div class="box sc-analytics-summary__box">
        <sc-tooltip
          :label="summary.title"
          :position="getTooltipPosition(index)"
          type="is-white"
          class="sc-analytics-summary__box__help">
          <sc-icon icon="question-circle" />
        </sc-tooltip>

        <div class="sc-analytics-summary__box__title">
          {{ summary.title }}
        </div>

        <div class="sc-analytics-summary__box__value">
          {{ getFormattedValue(summary.value) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { ScPageLoading, ScTooltip, ScIcon } from '@intelipost-js/secure-components';

const { mapState, mapActions } = createNamespacedHelpers('recon/analytics/summary');

export default {
  name: 'sc-analytics-summary',
  computed: {
    ...mapState([
      'loading',
      'summaries',
    ]),
  },
  methods: {
    ...mapActions([
      'getAnalyticsSummary',
    ]),
    loadData(form) {
      this.getAnalyticsSummary(form);
    },
    getTooltipPosition(index) {
      return index === this.summaries.length - 1 ? 'is-left' : 'is-bottom';
    },
    getFormattedValue(value) {
      if (!Number.isInteger(value) && typeof value === 'number') {
        return this.$options.filters.currency(value);
      }

      return value;
    },
  },
  components: {
    ScPageLoading,
    ScIcon,
    ScTooltip,
  },
};
</script>
<style lang="scss" scoped>
@import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line

.sc-analytics-summary {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: visible;
  max-width: calc(100vw - 47px);

  &__box {
    height: 100%;
    min-width: 180px;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid transparent;
    position: relative;
    padding: 1rem;

    @media (min-width: 1280px) {
      min-width: auto;
    }

    &:hover {
      border-color: $primary,
    }

    &__help {
      color: $grey-lighter;
      position: absolute;
      top: 5px;
      right: 5px;

      &:hover {
        color: $label-color;
        cursor: help;
      }
    }

    &__title {
      color: $label-color;
      font-size: 1rem;
      line-height: 1.3;
      font-weight: bold;
      padding-right: 15px;

      @media (min-width: 1200px) {
        margin: 0 0 10px;
      }
    }

    &__value {
      color: $primary;
      font-size: 1.4rem;
      font-weight: bold;
      letter-spacing: -1px;

      @media (min-width: 1000px) {
        letter-spacing: -1px;
      }

      @media (min-width: 1280px) {
        font-size: 1.6rem;
      }

      @media (min-width: 1480px) {
        font-size: 1.8rem;
      }

      @media (min-width: 1600px) {
        font-size: 2.2rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/analytics/components/analytics-summary/ScAnalyticsSummary.vue